<template>
  <div>
      <div v-if="profile.isAuthenticated">
          <hp5-heading v-if="isTravelNetwork" id="search-a-network" tag-selection="h1" size-selection="xl">Far From Home network</hp5-heading>
          <hp5-heading v-if="!isTravelNetwork" id="search-a-network" tag-selection="h1" size-selection="xl">Find care in your network</hp5-heading>
      </div>

      <div v-if="!profile.isAuthenticated">
          <hp5-heading id="search-a-network" tag-selection="h1" size-selection="xl">Search a network</hp5-heading>
          <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
          <hp5-semantic size-selection="sm">
              <p>
              <!-- easy way to show the currentPlan name and have it not update when a user is toggling
              the network filter options but hasn't applied the filters. Also allows the default plan name to show
              in the heading before a non-auth user has performed an initial search bc currentPlanName hasn't been
              computed yet -->
              <b v-if="!hasSearched">{{ plan.name }}</b>
              <b v-else>{{ currentPlanName }}</b>
              <br />
              If you’re already a member, <a data-analytics="login-1" href="/public/login/?referrer=%2Ffcp%2Fcsearch">sign in to search your specific plan’s network</a>.
              Not a member yet? Search the network below.
            </p>
          </hp5-semantic>
      </div>
  </div>
</template>

<script setup>
  const { profile, plan, hasSearched, currentPlanName } = useFCPModel()
  const isTravelNetwork = computed(() => plan.value.isTravelNetwork )
</script>